export default "__VITE_ASSET__Cu0Wf8kq__"